
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organizations/[organizationId]/dashboard",
      function () {
        return require("private-next-pages/organizations/[organizationId]/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organizations/[organizationId]/dashboard"])
      });
    }
  